import { get_api_path } from "services/api";
import { store } from "../store";
import { sessioned_client } from "./auth";

export async function list({ query }) {
  const url = get_api_path("item_class/list", query);
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { models, meta } = response.data.result;
  return { models, meta };
};

export async function detail(item_class_id) {
  const url = get_api_path("item_class/detail", {}, { item_class_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { model } = response.data.result;
  return { model };
};

export async function del(item_class_id) {
  const url = get_api_path("item_class/delete", {}, { item_class_id });
  const { token } = store.getState().profile;
  await sessioned_client(token).delete(url);
};

export async function update(item_class_id, data) {
  const url = get_api_path("item_class/update", {}, { item_class_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};

export async function create(data) {
  const url = get_api_path("item_class/create");
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};